import script from "./ShowEntitlementLogsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowEntitlementLogsModal.vue?vue&type=script&setup=true&lang=js"

export default script